'use strict';

angular.module('kerp-forms.forms').config(['schemaFormDecoratorsProvider', 'sfBuilderProvider', 'configuration',
  function (schemaFormDecoratorsProvider, sfBuilderProvider, configuration) {

    schemaFormDecoratorsProvider.defineAddOn(
      // Name of the decorator you want to add to
      'bootstrapDecorator',

      // Form type that should render this add-on
      'careAssessmentResult',

      // Template name in $templateCache
      'modules/forms/scripts/careAssessment/' + configuration.customer + '/careAssessmentResultDirective.html',

      // List of builder functions to apply
      sfBuilderProvider.stdBuilders
    );
  }]);
